import { connect } from "react-redux"
import { compose } from "redux"
import ComparativeReport from '../components/comparative-report'
import { getVariables } from "../utilities/route"
import { withData } from "../decorators/with-data"
import gql from "graphql-tag"
import { withTranslations } from "../decorators/with-translations"
import { setSortAscending, setCrSortingType, setFilters } from '../actions/survey'
import {
  SURVEY_LIST_PARAMETER_FRAGMENT,
  SURVEY_TREE_PARAMETER_FRAGMENT
} from "../graphql/fragments"
import { YOU_FILTER, toNormalizedRespondentFilters } from '../utilities/helpers'
import { isEqual } from 'lodash-es'

const comparativeReportQuery = gql`
  query ComparativeReports(
      $surveyId: UUID!
      $topicId: UUID
      $topicType: String!
      $respondentFilters: [RespondentFilterInput!]
      $languageCode: String
  ) {
    afterGameComparativeParameterStatistics (
      surveyId: $surveyId
      topicId: $topicId
      topicType: $topicType
      respondentFilters: $respondentFilters
      languageCode: $languageCode
    ) {
      totalResult
      totalRate
      topic
      parameters {
        label
        parents
        result
        rate
        message
      }
    }
    respondentParameters(
      surveyId: $surveyId
      languageCode: $languageCode
    ) {
      ...SurveyListParameter
      ...SurveyTreeParameter
    }
  }
  ${SURVEY_LIST_PARAMETER_FRAGMENT}
  ${SURVEY_TREE_PARAMETER_FRAGMENT}
`;

const mapStateToProps = ({ survey: { sortAscending, crSortingType, filters } }) => {
  return {
    sortAscending,
    crSortingType,
    filters,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSetCrSortingType: (type) => {
      dispatch(setCrSortingType(type));
    },
    onSetSortAscending: (ascending) => {
      dispatch(setSortAscending(ascending));
    },
    onSetFilters: filters => {
      dispatch(setFilters(filters))
    },
  };
}

const getTopicType = (crSection) => {
  switch (crSection) {
    case 'themes':
      return "THEME";
    case 'drivers':
      return "DRIVER";
    case 'statements':
      return "STATEMENT";
    default:
      return "OVERALL";
  }
}

export default compose(
  withTranslations,
  connect(mapStateToProps, mapDispatchToProps),
  withData(comparativeReportQuery, {
    options: (props) => {
      const variables = { ...getVariables(props) };

      variables.variables.topicId = getTopicType(props.crSection) === "OVERALL" ? undefined : props.crReportId;
      variables.variables.topicType = getTopicType(props.crSection);

      props.onSetFilters((props.filters && !isEqual(props.filters, YOU_FILTER)) ? props.filters : []);
      variables.variables.respondentFilters = toNormalizedRespondentFilters(props.filters);

      return {
        ...variables,
        fetchPolicy: "network-only",
      };
    },
  })
)(ComparativeReport)



// WEBPACK FOOTER //
// ./src/containers/comparative-report.js